import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { icon: 'description', label: 'My Applications', path: '/agent/applications' },
  { icon: 'work', label: 'My Openings', path: '/agent/openings' },
  { icon: 'payments', label: 'Payments', path: '/agent/payments' },
  { icon: 'menu_book', label: 'Course Imports', path: '/agent/courses/import' },
  { icon: 'domain', label: 'Institutions', path: '/agent/institutions' },
  { icon: 'public', label: 'Country Guides', path: '/agent/country-guides' },
];

export default function AgentSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-[#e2e8f0] flex items-center justify-between px-4 z-40">
        <button onClick={() => setIsOpen(true)} className="p-2 text-[#00255a]">
          <span className="material-symbols-outlined">menu</span>
        </button>
        <h1 className="text-lg font-bold text-[#00255a]">Agent Workspace</h1>
        <div className="w-10" />
      </div>

      {isOpen && <div onClick={close} className="fixed inset-0 bg-black/40 z-40 md:hidden" />}

      <aside
        className={`fixed left-0 top-0 h-screen w-64 flex flex-col py-8 bg-white shadow-[0px_10px_30px_rgba(30,60,114,0.05)] border-r border-[#e2e8f0] z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
      >
        <div className="px-6 mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#00255a]">Agent Workspace</h1>
            <p className="text-xs text-[#64748b] mt-1">IASC Consultancy</p>
          </div>
          <button onClick={close} className="md:hidden p-1 text-[#64748b]">
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto space-y-1 px-4 min-h-0">
          {NAV_ITEMS.map((item) => {
            const active = location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={close}
                className={`flex items-center px-4 py-3 rounded-lg font-semibold transition-all text-sm ${
                  active ? 'text-[#00255a] bg-[#e6e8ea] border-r-4 border-[#00255a]' : 'text-[#64748b] hover:bg-[#f2f4f6] hover:text-[#00255a]'
                }`}
              >
                <span className="material-symbols-outlined mr-3">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="flex-shrink-0 px-4 pt-4 mt-4 border-t border-[#e2e8f0]">
          <button
            onClick={() => { localStorage.removeItem('token'); navigate('/login'); }}
            className="w-full flex items-center px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f2f4f6] hover:text-[#00255a] transition-all text-sm text-left"
          >
            <span className="material-symbols-outlined mr-3">logout</span>
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}